import Lazyload from 'vue-lazyload';
export default Lazyload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@2.9.3@vant/es/lazyload/index.js
// module id = 157
// module chunks = 0